import React from "react";
import PropTypes from "prop-types";
import { InfoTitle, InfoField, InfoFieldAdditionalAttribute } from "../style";

export default function InfoBlock({
  title,
  value,
  value2,
  breakAll = false,
  confirmationPage = false,
}) {
  return (
    <>
      <InfoTitle>{title}</InfoTitle>
      {confirmationPage ? (
        <>
          <InfoFieldAdditionalAttribute wordBreakOnly={!breakAll}>
            {value}
          </InfoFieldAdditionalAttribute>
          {value2 && (
            <InfoFieldAdditionalAttribute>
              {value2}
            </InfoFieldAdditionalAttribute>
          )}
        </>
      ) : (
        <>
          <InfoField wordBreakOnly={!breakAll}>{value}</InfoField>
          {value2 && <InfoField>{value2}</InfoField>}
        </>
      )}
    </>
  );
}

InfoBlock.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  value2: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  breakAll: PropTypes.bool,
  confirmationPage: PropTypes.bool,
};
